// Group Service - OOP Business Logic
import { GroupRepository } from '../repositories/GroupRepository';
import { IGroup, IGroupDetail, ICreateGroupRequest } from '../interfaces/IGroup';

export class GroupService {
  constructor(private groupRepository: GroupRepository) {}

  async createGroup(data: ICreateGroupRequest): Promise<IGroup> {
    return this.groupRepository.create(data);
  }

  async getAllGroups(): Promise<IGroup[]> {
    return this.groupRepository.getAll();
  }

  async getGroupById(id: string): Promise<IGroupDetail> {
    return this.groupRepository.getById(id);
  }

  async updateGroup(id: string, data: Partial<IGroup>): Promise<IGroup> {
    return this.groupRepository.update(id, data);
  }

  async deleteGroup(id: string): Promise<void> {
    return this.groupRepository.delete(id);
  }
}
